// extracted by mini-css-extract-plugin
export default {"tagWrapper":"SpecialPlacesView_tagWrapper__1upe+","headerDescriptionsRow":"SpecialPlacesView_headerDescriptionsRow__yMbAo"};